<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper no-footer">

    <aside class="rope movie"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn class="movie"></app-back-btn>
    <section class="listen ">

      <div class="inner wrap flex-column">

        <app-search-box [keyword]="keyword"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_VIDEO"
                        [keyHistoryView]="HISTORY_KEY_VIEW_VIDEO"
                        placeholder="영상을 검색 합니다."
                        [top]="scrollTop"
                        (goHistory)="onGoHistory()"
                        (search)="SearchVideo($event)"></app-search-box>

        <div #container
             class="listen-body-box scroll-effect2 over-y flex-grow">

          <div *ngFor="let cat of videoCollect.ListCategory; let idx=index"
               class="row cat-{{ idx }}">
            <div class="subject-box type-{{ findVideoData(cat.category)?.cssIdx ?? '1' }}">
              <div class="subject-txt">
                {{ findVideoData(cat.category)?.name ?? '카테고리 없음' }}
                <button *ngIf="isShowMoreButton(cat)"
                        class="btn-more"
                        (click)="onClickSeeMore(cat.category)">
                  더 보기
                </button>
              </div>
            </div>

            <div class="swiper-box">
              <div class="custom-button-prev"></div>
              <div class="swiper listen-video-list">
                <div class="swiper-wrapper">
                  <div class="swiper-slide item-slide"
                       *ngFor="let video of cat.videoCollect">
                    <app-video-box [video]="video"
                                   (bookmarkChange)="onBookmarkChange($event, cat.videoCollect)"></app-video-box>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
              <div class="custom-button-next"></div>
            </div>
          </div>

          <!-- 로딩중 표시 -->
          <div class="reload-icon" *ngIf="IsLoading">
            <img src="assets/img/loading_icon.gif">
          </div>

          <!-- 로딩 항목이 없을 때 -->
          <div class="no-result" *ngIf="IsComplete && listVideo?.length === 0">
            <div class="no-result-img"></div>
            <div class="no-result-txt">영상이 없습니다.</div>
          </div>

        </div>

      </div>

    </section>


  </div>

  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>

</div>
